var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.033 22.1021L23.273 19.8621C23.5747 19.5642 23.9564 19.3602 24.3718 19.275C24.7872 19.1898 25.2184 19.227 25.613 19.3821L28.343 20.4721C28.7418 20.634 29.0838 20.9103 29.3258 21.2662C29.5678 21.6221 29.6991 22.0417 29.703 22.4721V27.4721C29.7007 27.7649 29.6391 28.0542 29.5221 28.3225C29.405 28.5909 29.2349 28.8328 29.0218 29.0337C28.8088 29.2345 28.5574 29.3902 28.2826 29.4914C28.0078 29.5925 27.7154 29.637 27.423 29.6221C8.29301 28.4321 4.43301 12.2321 3.70301 6.03211C3.66913 5.72765 3.70009 5.41946 3.79386 5.12782C3.88764 4.83618 4.0421 4.5677 4.24708 4.34005C4.45207 4.11239 4.70293 3.93072 4.98317 3.80697C5.26341 3.68323 5.56668 3.62023 5.87301 3.62211H10.703C11.134 3.62339 11.5548 3.75358 11.9112 3.99594C12.2676 4.2383 12.5434 4.58175 12.703 4.98211L13.793 7.71211C13.9533 8.10518 13.9942 8.53675 13.9106 8.95292C13.827 9.36909 13.6226 9.75141 13.323 10.0521L11.083 12.2921C11.083 12.2921 12.373 21.0221 21.033 22.1021Z",
    fill: "#5935A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c724a99993f9f39f43293a0e2ecfeee1.svg";
export { ForwardRef as ReactComponent };